import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import Header from '../layout/Header';
import Navigation from '../layout/Navigation';
import Notification from '../layout/Notification';
import DashboardPage from '../../pages/DashboardPage';
import ProverbsPage from '../../pages/ProverbsPage';
import AnalyticsPage from '../../pages/AnalyticsPage';
import UsersPage from '../../pages/UsersPage';
import useNotification from '../../hooks/useNotification';
import './dashboard.css';

const Dashboard = () => {
  const { user } = useAuth();
  const [activeSection, setActiveSection] = useState('dashboard');
  const { notification, hideNotification } = useNotification();

  // Role-based access control helpers
  const isSuperAdmin = () => user?.role_id === 1;
  const isAdmin = () => user?.role_id === 2;
  const canManageProverbs = () => isSuperAdmin() || isAdmin();
  const canManageUsers = () => isSuperAdmin();

  const renderActiveSection = () => {
    switch (activeSection) {
      case 'dashboard':
        return <DashboardPage setActiveSection={setActiveSection} />;
      case 'proverbs':
        return canManageProverbs() ? <ProverbsPage /> : <DashboardPage setActiveSection={setActiveSection} />;
      case 'proverbs-add':
        // Auto-open add modal and reset to normal proverbs view
        setActiveSection('proverbs');
        return canManageProverbs() ? <ProverbsPage autoOpenAdd={true} /> : <DashboardPage setActiveSection={setActiveSection} />;
      case 'analytics':
        return <AnalyticsPage />;
      case 'users':
        return canManageUsers() ? <UsersPage /> : <DashboardPage setActiveSection={setActiveSection} />;
      default:
        return <DashboardPage setActiveSection={setActiveSection} />;
    }
  };

  return (
    <div className="dashboard">
      {/* Notification */}
      <Notification notification={notification} onClose={hideNotification} />

      {/* Header */}
      <Header />

      {/* Navigation */}
      <Navigation activeSection={activeSection} setActiveSection={setActiveSection} />

      {/* Main Content */}
      <div className="dashboard-content">
        {renderActiveSection()}
      </div>
    </div>
  );
};

export default Dashboard;
